export default __webpack_public_path__ + "static/media/hierslapenwijKlein.f9ee6d39.jpg";